import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import {CallRestaurant, CallRestaurantWrapper, Form, Textarea, Thankyou, Title} from './CheckoutErrorReportModal.style';
import {Button2} from '../../styles/components/button.style';
import {defaultStyles} from '../Modal/modal.config';
import {Wrapper} from '../Modal/modal.style';
import {FormattedMessage} from 'react-intl';

class CheckoutErrorReportModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
      sent: false,
      message: null
    };
    this.initModal = this.initModal.bind(this);
    this.handleSendReport = this.handleSendReport.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCallRestaurant = this.handleCallRestaurant.bind(this);
  }

  initModal() {
    return document.body;
  }

  handleSendReport() {
    const {message} = this.state;
    const {restaurant, sendSlackMessage} = this.props;

    if (!this.state.sent) {
      sendSlackMessage(`${restaurant.name} (${restaurant.contactNumber})`, message, window.location.href)
        .then(() => this.setState({sent: true}));
    }
  }

  handleChange(event) {
    this.setState({message: event.target.value});
  }

  handleCallRestaurant(phone) {
    window.location.href = `tel://${phone}`;
  }

  render() {
    const {handleCloseModal, phone, isMobile} = this.props;
    const renderForm = !this.state.sent && (
      <Form>
        <Textarea
          placeholder={'Please provide any details describing the error you have experienced (optional)'}
          onChange={this.handleChange}
        >
          {this.state.message}
        </Textarea>
      </Form>
    );
    const renderTitle = <FormattedMessage id={this.state.sent ? 'checkoutErrorReportModal.title.thankyou' : 'checkoutErrorReportModal.title'} />;
    const renderThankYou = this.state.sent && (<Thankyou><FormattedMessage id="checkoutErrorReportModal.thankyou" /></Thankyou>);
    const renderButton = this.state.sent ? (
      <Button2 onClick={handleCloseModal}><FormattedMessage id="checkoutErrorReportModal.close" /></Button2>
    ) : (
      <Button2 onClick={this.handleSendReport}><FormattedMessage id="checkoutErrorReportModal.send" /></Button2>
    );
    const renderCallRestaurant = isMobile ? (
      <CallRestaurantWrapper>
        <Button2 onclick={this.handleCallRestaurant}>
          <FormattedMessage
            id="checkoutErrorReportModal.callRestaurant"
            values={{phone}}
          />
        </Button2>
      </CallRestaurantWrapper>
    ) : (
      <CallRestaurant>
        <FormattedMessage
          id="checkoutErrorReportModal.callRestaurant"
          values={{phone}}
        />
      </CallRestaurant>
    );

    return (
      <Modal
        isOpen={this.state.showModal}
        style={defaultStyles}
        onRequestClose={handleCloseModal}
        parentSelector={this.initModal}
        contentLabel="Modal"
        shouldCloseOnOverlayClick={false}
      >
        <Wrapper>
          <Title>{renderTitle}</Title>
          {renderForm}
          {renderThankYou}
          {renderCallRestaurant}
          {renderButton}
        </Wrapper>
      </Modal>
    );
  }
}

CheckoutErrorReportModal.propTypes = {
  handleCloseModal: PropTypes.func.isRequired,
  phone: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  restaurant: PropTypes.object.isRequired,
  sendSlackMessage: PropTypes.func.isRequired
};

export default CheckoutErrorReportModal;




// WEBPACK FOOTER //
// ./components/CheckoutErrorReportModal/CheckoutErrorReportModal.js